import styled from 'styled-components';

import { Search } from 'components/atoms';

export const SearchIcon = styled(Search)`
  display: flex;
  position: absolute;
  top: 0;
  left: 1rem;
  width: 1.5rem;
  height: 3.7rem;
  z-index: 1;
`;

